/**
 * Collection Grid Enhancements
 * - Image slider with prev/next arrows and dot indicators
 * - Quick Add to Cart (single variant: add directly; multi-variant: go to product)
 *
 * File: assets/collection-grid-enhancements.js
 */

(function () {
  'use strict';

  // ─── Image Slider ────────────────────────────────────────────────────────────

  function initSlider(card) {
    var mask = card.querySelector('.grid-product__image-mask--slider');
    if (!mask) return;

    var slides = mask.querySelectorAll('.grid-product__slide');
    if (slides.length <= 1) return;

    var dots = mask.querySelectorAll('.grid-product__slider-dot');
    var prevBtn = mask.querySelector('.grid-product__slider-arrow--prev');
    var nextBtn = mask.querySelector('.grid-product__slider-arrow--next');
    var currentIndex = 0;
    var total = slides.length;

    function goTo(index) {
      // bounds wrap
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;

      // hide current
      slides[currentIndex].classList.remove('grid-product__slide--active');
      if (dots[currentIndex]) dots[currentIndex].classList.remove('grid-product__slider-dot--active');

      currentIndex = index;

      // show new
      slides[currentIndex].classList.add('grid-product__slide--active');
      if (dots[currentIndex]) dots[currentIndex].classList.add('grid-product__slider-dot--active');

      // Trigger lazyload for the newly visible image
      var lazyImg = slides[currentIndex].querySelector('img.lazyload');
      if (lazyImg && window.lazySizes) {
        window.lazySizes.loader.unveil(lazyImg);
      }
    }

    // Arrow clicks — stop link navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex + 1);
      });
    }

    // Dots clicks
    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
        if (!isNaN(idx)) goTo(idx);
      });
    });

    // Touch swipe support
    var touchStartX = 0;
    mask.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    mask.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
    }, { passive: true });
  }

  // ─── Quick Add to Cart ───────────────────────────────────────────────────────

  function initQuickAdd(card) {
    var btn = card.querySelector('.grid-product__quick-add');
    if (!btn) return;

    // Multi-variant: is an <a> tag already, no JS needed
    if (btn.tagName === 'A') return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      // Show loading state
      btn.classList.add('grid-product__quick-add--loading');

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      fetch(window.Shopify ? '/cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
        credentials: 'same-origin',
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.classList.remove('grid-product__quick-add--loading');

        if (data.status && data.status !== 200) {
          // Error — navigate to product page
          window.location = btn.closest('.grid-product').querySelector('.grid-product__link').href;
          return;
        }

        // Success feedback
        btn.classList.add('grid-product__quick-add--success');

        // Swap icon to checkmark
        btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><polyline points="20 6 9 17 4 12"></polyline></svg>';

        // Dispatch cart:updated so the theme re-renders the cart count
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: data }
        }));

        // Also trigger the theme's built-in cart refresh if CartDrawer is present
        if (window.theme && window.theme.cart) {
          window.theme.cart.getCart().then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            // Update bubble count
            updateCartCount(cart.item_count);
          });
        }

        // Reset button after 2s
        setTimeout(function () {
          btn.classList.remove('grid-product__quick-add--success');
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path><line x1="12" y1="10" x2="12" y2="16"></line><line x1="9" y1="13" x2="15" y2="13"></line></svg>';
        }, 2000);

        // If cart type = drawer, open it
        if (window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer') {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
      })
      .catch(function () {
        btn.classList.remove('grid-product__quick-add--loading');
        // On error, navigate to product page
        var link = btn.closest('.grid-product') && btn.closest('.grid-product').querySelector('.grid-product__link');
        if (link) window.location = link.href;
      });
    });
  }

  // ─── Update cart bubble count ────────────────────────────────────────────────

  function updateCartCount(count) {
    // Update count badges
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) {
      el.innerText = count;
    });

    // Show/hide bubble
    document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
      if (count > 0) {
        bubble.classList.add('cart-link__bubble--visible');
      } else {
        bubble.classList.remove('cart-link__bubble--visible');
      }
    });
  }

  // ─── Init all cards ──────────────────────────────────────────────────────────

  function initCards(scope) {
    var container = scope || document;
    container.querySelectorAll('.grid-product').forEach(function (card) {
      // Avoid double-init
      if (card.dataset.sliderInit) return;
      card.dataset.sliderInit = 'true';

      initSlider(card);
      initQuickAdd(card);
    });
  }

  // ─── Boot ────────────────────────────────────────────────────────────────────

  // Wait for page to be ready (works with theme's own page:loaded event)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCards(); });
  } else {
    initCards();
  }

  // Also hook into Shopify's theme page:loaded event for AJAX filtered collections
  document.addEventListener('page:loaded', function () { initCards(); });

  // Re-init after AJAX collection filters update the grid
  document.addEventListener('recommendations:loaded', function (e) {
    if (e.detail && e.detail.section) {
      initCards(e.detail.section);
    }
  });

  // MutationObserver for AJAX-rendered collection grids (filter/sort updates)
  var gridObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('grid-product')) {
            if (!node.dataset.sliderInit) {
              node.dataset.sliderInit = 'true';
              initSlider(node);
              initQuickAdd(node);
            }
          } else {
            initCards(node);
          }
        }
      });
    });
  });

  var collectionGrid = document.getElementById('CollectionAjaxContent');
  if (collectionGrid) {
    gridObserver.observe(collectionGrid, { childList: true, subtree: true });
  }

})();